'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getComponent = getComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getComponent(option, getProps) {
  if (option === false) {
    return function () {
      return EmptyComponent;
    };
  } else if (!option && !getProps) {
    return function (BaseComponent) {
      return BaseComponent;
    };
  }
  var AppointComponent = void 0;
  var propValues = {};
  if (option && option.prototype && option.prototype.isReactComponent) {
    AppointComponent = option;
  } else {
    propValues = option || {};
  }

  var decorator = function decorator(BaseComponent) {
    AppointComponent = AppointComponent || BaseComponent || EmptyComponent;

    var Component = function (_React$PureComponent) {
      _inherits(Component, _React$PureComponent);

      function Component(props) {
        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, props));

        if (BaseComponent && !BaseComponent.prototype.isReactComponent) {
          _this.state = {
            stateProps: {},
            Component: EmptyComponent
          };
          _this._getComponent = BaseComponent;
        } else {
          _this.state = {
            stateProps: {},
            Component: AppointComponent
          };
        }
        return _this;
      }

      _createClass(Component, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.mounted = true;
          if (this._getComponent) {
            this._getComponent(this.context, function (err, component, props) {
              if (err) {
                window.console.error(err);
              } else {
                if (_this2.mounted) {
                  _this2.setState({
                    stateProps: props || {},
                    Component: component
                  });
                }
              }
            }, function (nextState) {
              return _this2.setState({ stateProps: Object.assign({}, _this2.state.stateProps, nextState) });
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.mounted = false;
        }
      }, {
        key: 'getRealInstance',
        value: function getRealInstance() {
          return this._wrappedComponent;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var _state = this.state,
              stateProps = _state.stateProps,
              Component = _state.Component;

          var newProps = Object.assign({}, propValues);
          for (var key in this.props) {
            if (newProps[key] === undefined) {
              newProps[key] = this.props[key];
            }
          }
          var asyncProps = getProps ? getProps(newProps, this.context, function (nextProps) {
            _this3.setState({
              stateProps: Object.assign({}, _this3.state.stateProps, nextProps)
            });
          }) : {};
          return _react2.default.createElement(Component, _extends({ ref: function ref(inst) {
              return _this3._wrappedComponent = inst;
            } }, newProps, asyncProps, stateProps));
        }
      }]);

      return Component;
    }(_react2.default.PureComponent);

    var newComponent = (0, _hoistNonReactStatics2.default)(Component, AppointComponent);
    if (BaseComponent && BaseComponent.contextTypes) {
      newComponent.contextTypes = Object.assign(newComponent.contextTypes || {}, BaseComponent.contextTypes);
    }
    return newComponent;
  };
  return decorator;
}

/* eslint-disable react/prop-types */
function EmptyComponent(props) {
  return _react2.default.createElement(
    'span',
    { id: props.id },
    props.children
  );
}
getComponent.emptyComponent = EmptyComponent;


//////////////////
// WEBPACK FOOTER
// ./src/layouts/getComponent.jsx
// module id = 5
// module chunks = 0